
export type ChangeSubscriptionPlan200NewSubscription = {
  amount?: number;
  effectiveDate?: string;
  productName?: string;
  subscriptionId?: string;
};
